var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailIcon = function SvgMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M9.332 11.92a.953.953 0 0 0 1.328 0l7.267-7.268a.375.375 0 0 0-.024-.551.4.4 0 0 0-.185-.086L17.5 4H2.283a.38.38 0 0 0-.3.255.36.36 0 0 0 .09.383z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M18.918 5.372a.14.14 0 0 0-.15 0l-4.65 4.65a.18.18 0 0 0 0 .27l3.75 3.75a.563.563 0 0 1-.795.796l-3.75-3.75a.19.19 0 0 0-.209-.043.2.2 0 0 0-.062.043l-1.597 1.597a2.07 2.07 0 0 1-2.918 0l-1.59-1.568a.18.18 0 0 0-.27 0l-3.75 3.75a.563.563 0 0 1-.794-.795l3.75-3.75a.18.18 0 0 0 0-.27l-4.65-4.65a.14.14 0 0 0-.15 0A.14.14 0 0 0 1 5.5v9A1.5 1.5 0 0 0 2.5 16h15a1.5 1.5 0 0 0 1.5-1.5v-9a.135.135 0 0 0-.082-.128"
  })));
};
export { SvgMailIcon as ReactComponent };